import React, { useEffect, useState } from "react";
import { useAuth } from "./auth";
import { getTenantByID, getTenantByRoom, updateTenant } from "./apiService";
import { useNavigate } from "react-router-dom";

const EditGuest = () => {
  const [guestname, setGuestname] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [aadharno, setAadharno] = useState("");
  const [joindate, setJoindate] = useState("");
  const [rentamt, setRentamt] = useState("");
  const [advamt, setAdvamt] = useState("");
  const [balamt, setBalamt] = useState("");
  const [paymentdate, setPaymentdate] = useState("");
  const [paidstatus, setPaidstatus] = useState(false);
  const [errors, setErrors] = useState({});
  const [guests, setGuests] = useState([]);
  const navigate = useNavigate();
  const { roomid, guestid, pgid } = useAuth();

  useEffect(() => {
    getTenantByID(guestid)
      .then((res) => {
        setGuestname(res.name);
        setMobileno(res.mobileno);
        setAadharno(res.aadharNo);
        setJoindate(res.joinedDate);
        setRentamt(res.rentAmt);
        setAdvamt(res.advAmt);
        setBalamt(res.balAmt);
        setPaidstatus(res.paid);
        setPaymentdate(res.paymentDate);
      })
      .catch((e) => console.log(e));

    getTenantByRoom(roomid)
      .then((res) => {
        setGuests(res);
      })
      .catch((e) => console.log(e));
  }, [guestid, roomid]);

  const handleTenantEditSubmit = () => {
    let errors = {};
    const re1 = new RegExp("^[6-9][0-9]{9}$");
    const re2 = new RegExp("^[0-9]{12}$");

    if (!guestname) errors.guestname = "Guest name is required";
    if (!re1.test(mobileno)) errors.mobileno = "Enter valid mobile number";
    if (!re2.test(aadharno)) errors.aadharno = "Enter valid aadhar number";
    if (!joindate) errors.joindate = "select valid joining date";
    if (!rentamt) errors.rentamt = "Enter Tenant rent amount";
    if (!advamt) errors.advamt = "Enter Tenant Advance amount";
    if (!paymentdate) errors.paymentdate = "Enter Tenant next payment date";

    guests.forEach((guest) => {
      if (guest.name === guestname && guest.id !== guestid) {
        errors.guestname = "guest already exists with same name";
        // console.log(errors.username);
      }
      if (guest.mobileno === mobileno && guest.id !== guestid) {
        errors.mobileno = "Another guest with same Mobile No..??";
        // console.log(errors.mobileno);
      }
      if (guest.aadharNo === aadharno && guest.id !== guestid) {
        errors.aadharno = "Gust is there with same Aadhar NO";
      }

      return errors;
    });

    setErrors(errors);

    // console.log(Object.keys(fguests).length);

    if (Object.keys(errors).length === 0) {
      const tenant = {
        name: guestname,
        mobileno: mobileno,
        aadharNo: aadharno,
        joinedDate: joindate,
        rentAmt: rentamt,
        balAmt: balamt,
        advAmt: advamt,
        paymentDate: paymentdate,
        paid: paidstatus,
        pgname: pgid,
        roomNo: roomid,
      };

      updateTenant(tenant, guestid);

      setGuestname("");
      setMobileno("");
      setAadharno("");
      setJoindate("");
      setRentamt("");
      setAdvamt("");
      setPaymentdate("");
      setPaidstatus(false);
      navigate("/Dashboard/MyPGDetails/RoomDetails");
    }
  };
  return (
    <div className="container">
      <div className="header">EDIT Guest</div>
      <div className="label">
        Guest Name:
        <input
          type="text"
          className="inputbox"
          name="pgname"
          defaultValue={guestname}
          onChange={(e) => setGuestname(e.target.value)}
        />
        {errors.guestname ? (
          <div className="errortext">{errors.guestname}</div>
        ) : null}
      </div>

      <div className="label">
        Mobile No:
        <input
          type="text"
          className="inputbox"
          name="rooms"
          defaultValue={mobileno}
          onChange={(e) => setMobileno(e.target.value)}
        />
        {errors.mobileno ? (
          <div className="errortext">{errors.mobileno}</div>
        ) : null}
      </div>

      <div className="label">
        Aadhar No:
        <input
          type="text"
          className="inputbox"
          name="rooms"
          defaultValue={aadharno}
          onChange={(e) => setAadharno(e.target.value)}
        />
        {errors.aadharno ? (
          <div className="errortext">{errors.aadharno}</div>
        ) : null}
      </div>

      <div className="label">
        Joining Date:
        <input
          type="date"
          className="inputbox"
          name="rooms"
          defaultValue={joindate}
          onChange={(e) => setJoindate(e.target.value)}
        />
        {errors.joindate ? (
          <div className="errortext">{errors.joindate}</div>
        ) : null}
      </div>

      <div className="label">
        Rent Amount:
        <input
          type="text"
          className="inputbox"
          name="rooms"
          defaultValue={rentamt}
          onChange={(e) => setRentamt(e.target.value)}
        />
        {errors.rentamt ? (
          <div className="errortext">{errors.rentamt}</div>
        ) : null}
      </div>

      <div className="label">
        Advance Amount:
        <input
          type="text"
          className="inputbox"
          name="advamt"
          defaultValue={advamt}
          onChange={(e) => setAdvamt(e.target.value)}
        />
        {errors.advamt ? (
          <div className="errortext">{errors.advamt}</div>
        ) : null}
      </div>

      <div className="label">
        Balance Amount:
        <input
          type="text"
          className="inputbox"
          name="advamt"
          defaultValue={balamt}
          onChange={(e) => setBalamt(e.target.value)}
        />
        {errors.advamt ? (
          <div className="errortext">{errors.advamt}</div>
        ) : null}
      </div>

      <div className="label">
        Next Payment Date:
        <input
          type="date"
          className="inputbox"
          name="paymentdate"
          defaultValue={paymentdate}
          onChange={(e) => setPaymentdate(e.target.value)}
        />
        {errors.paymentdate ? (
          <div className="errortext">{errors.paymentdate}</div>
        ) : null}
      </div>

      <div className="label">
        Payment status:
        <input
          type="checkbox"
          className="inputbox"
          name="paidstatus"
          checked={paidstatus}
          onChange={(e) => setPaidstatus(!paidstatus)}
        />
        {errors.paymentdate ? (
          <div className="errortext">{errors.paymentdate}</div>
        ) : null}
      </div>

      <input
        type="submit"
        className="btn-cls"
        value="Submit"
        onClick={handleTenantEditSubmit}
      />
    </div>
  );
};

export default EditGuest;
